<template>
    <li class="nav-item h-full" @click.prevent="toggleDropdown">
        <div class="nav-link mx-0 relative" role="button">
            <svg class="p-2 small-menu-logo border-0 mx-0 cart-icon" fill="currentColor" version="1.1" viewBox="0 0 512 512" x="0"
                 xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:svgjs="http://svgjs.com/svgjs"
                 xmlns:xlink="http://www.w3.org/1999/xlink" y="0"><g transform="matrix(1,0,0,1,0,30)">
                <path class="" d="M164.96 300.004h.024c.02 0 .04-.004.059-.004H437a15.003 15.003 0 0 0 14.422-10.879l60-210a15.003 15.003 0 0 0-2.445-13.152A15.006 15.006 0 0 0 497 60H130.367l-10.722-48.254A15.003 15.003 0 0 0 105 0H15C6.715 0 0 6.715 0 15s6.715 15 15 15h77.969c1.898 8.55 51.312 230.918 54.156 243.71C131.184 280.64 120 296.536 120 315c0 24.812 20.188 45 45 45h272c8.285 0 15-6.715 15-15s-6.715-15-15-15H165c-8.27 0-15-6.73-15-15 0-8.258 6.707-14.977 14.96-14.996zM477.114 90l-51.43 180H177.032l-40-180zM150 405c0 24.813 20.188 45 45 45s45-20.188 45-45-20.188-45-45-45-45 20.188-45 45zm45-15c8.27 0 15 6.73 15 15s-6.73 15-15 15-15-6.73-15-15 6.73-15 15-15zM362 405c0 24.813 20.188 45 45 45s45-20.188 45-45-20.188-45-45-45-45 20.188-45 45zm45-15c8.27 0 15 6.73 15 15s-6.73 15-15 15-15-6.73-15-15 6.73-15 15-15zm0 0" data-original="#000000"></path></g>
            </svg>
            <div v-if="myCart && myCart.count" class="cart-count-icon font-weight-bold d-flex align-items-center justify-content-center text-white absolute right-[-10px] top-[-5px]">
                {{ myCart.count }}
            </div>
        </div>
        <div
            class="dropdown-menu dropdown-menu-right dropdown-menu-prof w-fit-content"
            :class="{show: showDropdown}">
            <div class="cart-wrapper">
                <template v-if="cart.count">
                    <div class="d-flex justify-content-between align-items-center cart-header">
                        <div class="d-flex align-items-center">
                            <h2 class="cart-title">{{trans('shop["cart.title"]')}}</h2>
                            <span class="cart-items-count">({{ myCart.count }})</span>
                        </div>
                        <span class="cart-remove-all" @click="emptyCart">{{trans('shop["cart.remove_all"]')}}</span>
                    </div>
                    <div class="cart-items">
                        <CartItem
                        :product="product"
                        v-for="(product, productIndex) in cart.items"
                        :key="`product-${productIndex}`"
                        :show-in-navbar="true"
                        @removeProduct="removeProduct"
                        />
                    </div>

                    <div class="d-flex flex-column cart-footer">
                        <div class="d-flex align-items-center justify-content-between mb-2">
                            <span class="cart-total-title">{{trans('shop["cart.total"]')}} </span>
                            <span class="cart-total-price">{{currency.toUpperCase()}}{{ cart.formatted_subtotal }}</span>
                        </div>
                        <button class="btn btn-primary py-2" @click="goToCart">{{trans('shop["cart.view_cart"]')}}</button>
                    </div>
                </template>
                <template v-else>
                    <div class="cart-empty">
                        <span class="mb-2">{{ trans('shop["cart.cart_is_empty"]') }}</span>
                        <button class="btn btn-primary py-2" @click="goToCatalogue">{{trans('shop["cart.keep_shopping"]')}}</button>
                    </div>
                </template>
            </div>
        </div>
    </li>
</template>

<script>
import axios from "axios";
import CartItem from "./CartItem.vue";
import Button from "../../../inertia/ts/Jetstream/Elements/Button/Button.vue";

export default {
    name: "NavbarCart",
    components: {
        Button,
        CartItem,
    },
    props: {
        cart: {
            type: [Object, null],
            default: null,
        },
        currency: {
            type: String,
        }
    },
    data: function() { return {
            showDropdown: false,
            myCart: this.cart,
        };
    },
    methods: {
        toggleDropdown() {
            this.showDropdown = !this.showDropdown
        },
        closeDropdown(e) {
            if (!this.$el.contains(e.target)) {
                this.showDropdown = false
            }
        },
        removeProduct(product) {
            axios.delete('/cart/' + product.id)
                .then((response) => {
                    location.reload();
                })
                .catch((error) => {
                    location.reload();
                })
        },
        emptyCart() {
            axios.delete('/cart/old')
                .then((response) => {
                    location.reload();
                })
                .catch((error) => {
                    console.log(error);
                })
        },
        goToCart() {
            window.location.href = '/cart';
        },
        goToCatalogue() {
            window.location.href = '/catalogue';
        }
    },
    mounted () {
        document.addEventListener('click', this.closeDropdown)
    },
    beforeDestroy () {
        document.removeEventListener('click',this.closeDropdown)
    }
}
</script>

<style lang="css" scoped>
.cart-icon {
    border-radius: 0;
    margin-top: -10px;
    width: 35px !important;
    height: 35px !important;
}

.nav-item:hover .cart-icon {
    color: #f77f00;
    fill: #f77f00;
}

.cart-count-icon {
    width: 21px;
    height: 21px;
    position: absolute;
    font-weight: 600;
    font-size: 15px;
    top: 5.5px;
    right: -5px;
    color: #fff;
    border-radius: 100%;
    background-color: rgb(247 127 0);
    border: 2px solid #fff;
    display: flex;
    align-items: center;
}

@media (min-width: 992px) {
    .cart-count-icon {
        width: 25px;
        height: 25px;
        font-size: 17.6px;
    }

    .cart-icon {
        width: 45px !important;
        height: 45px !important;
    }
}


.nav .nav-item .nav-link:hover .icon-cart {
    fill: rgb(247 127 0) !important;
}

.nav .nav-item .nav-link {
    color: gray;
}

.nav-item {
    position: relative;
}

.dropdown-menu {
    padding: 0;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15) !important;
    border: none;
}

.dropdown-menu-prof {
    position: fixed;
}

.dropdown-menu.dropdown-menu-right.show {
    width: 90%;
    max-width: 90% !important;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15) !important;
    border-radius: 0.5rem !important;
    margin: 0 auto;
    margin-top: 40px !important;
    top: 20px !important;
    left: 0 !important;

}

@media (min-width: 768px) {
    .dropdown-menu.dropdown-menu-right.show {
        width: 400px;
        min-width: 400px;
        top: 30px !important;
        left: auto !important;
        margin-top: 0;

    }

    .dropdown-menu-prof {
        position: absolute;
    }
}

.dropdown-menu.dropdown-menu-right.show {
    border: none;
}

.cart-header {
    margin-bottom: 2rem;
}

.cart-wrapper {
    padding: 30px;
}

.cart-title {
    font-size: 24px;
    line-height: 30px;
    margin: 0;
    margin-right: 0.5rem;
    padding: 0;
}

.cart-items-count {
    color: gray;
    font-size: 1rem;
    font-weight: 500;
}

.cart-items {
    max-height: 300px;
    overflow-y: auto;
    overflow-y: auto;
    padding-right: 0.75rem;
}

.cart-remove-all {
    color: gray;
    font-weight: 600;
    cursor: pointer;
    font-size: 0.9rem;
    line-height: 1.2;
}

.cart-remove-all:hover {
    color: rgb(247 127 0);
}

.cart-footer {
    gap: 0.5rem;
}

.cart-total-price {
    font-weight: bold;
    font-size: 1.875rem;
    line-height: 2.25rem;
    color: #21343d;
}

.cart-total-title {
    font-weight: bold;
    font-size: 1.1rem;
    line-height: 1.6rem;
}

.cart-empty {
    display: flex;
    flex-direction: column;
}

</style>
